/**
 * @generated SignedSource<<abe5d5c7147a4d14a09083242b46abd0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginForgotPasswordInput = {
  clientMutationId?: string | null | undefined;
  login: LoginForgotPassword;
};
export type LoginForgotPassword = {
  email: string;
};
export type ForgotPasswordLoginMutation$variables = {
  input: LoginForgotPasswordInput;
};
export type ForgotPasswordLoginMutation$data = {
  readonly loginForgotPassword: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
  };
};
export type ForgotPasswordLoginMutation = {
  response: ForgotPasswordLoginMutation$data;
  variables: ForgotPasswordLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordLoginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginForgotPasswordPayload",
        "kind": "LinkedField",
        "name": "loginForgotPassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ForgotPasswordLoginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginForgotPasswordPayload",
        "kind": "LinkedField",
        "name": "loginForgotPassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "101283fe4ad4d7b2651758d33b8e2841",
    "id": null,
    "metadata": {},
    "name": "ForgotPasswordLoginMutation",
    "operationKind": "mutation",
    "text": "mutation ForgotPasswordLoginMutation(\n  $input: LoginForgotPasswordInput!\n) {\n  loginForgotPassword(input: $input) {\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "336b0156d34e9cc474809a776151ceb7";

export default node;
